module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-2@2x.93da842b.jpg";